// extracted by mini-css-extract-plugin
export default {"root":"gift_card_store_cart_page_root__v2os7"};